<section class="wrapper period-picker__wrapper">
  <ng-container *ngIf="filters.get(filterTypesEnum.ViewType) === viewTypesEnum.ProjectPlanner">
    <div class="flex-row flex-row--align-center">
      <span class="text-bold pr-1" translate>Period:</span>
      <span translate>Month</span>
    </div>
  </ng-container>

  <ng-container *ngIf="showPeriod && filters.get(filterTypesEnum.ViewType) !== viewTypesEnum.ProjectPlanner">
    <app-select
      class="select-period"
      valueKey="value"
      displayKey="label"
      isFilter="true"
      [filterLabel]="'Period' | translate"
      [model]="periodTypeModel"
      [withoutSearch]="true"
      [withNone]="false"
      [disabled]="disabled"
      [optionList]="periodTypesList"
      (selectedValue)="updatePeriod($event, filterTypesEnum.Period)">
    </app-select>
  </ng-container>

  <div class="wrapper period-picker__date-container mx-1">
    <div (click)="updatePeriodDate($event, '-')" class="arrow">
      <i class="icon icon-Arrow_ico"></i>
    </div>

    <div class="date">
      <period-picker-calendar
        (dateChange)="updatePeriod($event, 'picker')"
        [period]="period"
        [fromDate]="fromDate"
        [toDate]="toDate"
        [isMobile]="isMobile">
      </period-picker-calendar>

      <span class="date__from">
        {{ fromDate | formatDate: 'DD' }}
        {{ fromDate | formatDate: 'MMM' | translate | lowercase }}
      </span>

      <span *ngIf="period !== 'day'" class="date__to">
        {{ toDate | formatDate: 'DD' | lowercase }}
        {{ toDate | formatDate: 'MMM' | translate | lowercase }}
      </span>
    </div>

    <div (click)="updatePeriodDate($event, '+')" class="arrow arrow__right">
      <i class="icon icon-Arrow_ico"></i>
    </div>
  </div>

  <button (click)="resetPeriodToToday($event)" class="period-picker__today-btn" translate>Today</button>

  <ng-content></ng-content>
</section>
